import { createGlobalStyle } from 'styled-components';
import { COLORS } from './constants/colors';

export const GlobalStyles = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;

        box-sizing: border-box;
        font-family: "Open Sans", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        -webkit-tap-highlight-color: transparent;
        -webkit-backface-visibility: hidden;
    }

    html,
    body,
    #root {
        position: relative;
        overflow: visible;
        min-width: 320px;
        height: 100%;
    }

    html,
    body {
        overflow-x: clip;
    }


    body {
        margin: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: 14px;
    }

    a {
        text-decoration: none;
        color: ${COLORS.$mainBlue};

        &:hover {
            color: inherit;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        &.ant-typography {
            margin-bottom: 0;
        }
    }

    a {
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
    }

    .ant-btn-secondary {
        background: #E6F0F9;
        color: ${COLORS.$mainBlue};
        border: 1.5px solid #DEE8F7;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: center;
    }

    /* Consistent Input Styles */
    .ant-input-lg, 
    .ant-select-lg .ant-select-selector,
    .ant-picker-large,
    .ant-input-number-lg,
    .ant-cascader-picker-large .ant-cascader-picker-input {
        height: 40px !important;
        font-size: 14px;
        line-height: 1.5;
        padding: 8px 12px;
    }

    .ant-select-lg .ant-select-selector {
        padding: 0 12px;
    }

    .ant-select-single.ant-select-lg {
        height: 40px !important;
    }

    .ant-select-single.ant-select-lg .ant-select-selector {
        height: 40px !important;
        display: flex;
        align-items: center;
    }

    .ant-select-lg .ant-select-selection-placeholder,
    .ant-select-lg .ant-select-selection-item {
        line-height: 40px;
        font-size: 14px;
    }

    .ant-input-search-lg .ant-input-group .ant-input {
        height: 40px !important;
        font-size: 14px;
    }

    .ant-input-search-lg .ant-input-group .ant-btn {
        height: 40px !important;
    }

    .ant-input-search .ant-input-group .ant-input {
        height: 40px !important;
        font-size: 14px;
    }

    .ant-input-search .ant-input-group .ant-btn {
        height: 40px !important;
    }

    /* Ensure search components don't exceed 40px */
    .ant-input-search.ant-input-search-large .ant-input-group .ant-input,
    .ant-input-search .ant-input-group .ant-input {
        height: 40px !important;
        max-height: 40px !important;
        min-height: 40px !important;
    }

    .ant-input-search.ant-input-search-large .ant-input-group .ant-btn,
    .ant-input-search .ant-input-group .ant-btn {
        height: 40px !important;
        max-height: 40px !important;
        min-height: 40px !important;
    }

    /* Button Styles */
    .ant-btn-primary {
        height: 40px;
        font-size: 14px;
        font-weight: 600;
        padding: 0 16px;
        border-radius: 8px;
        box-shadow: none !important;
        background-color: #1890ff !important;
        border-color: #1890ff !important;
        color: white !important;
        min-height: 40px !important;
        max-height: 40px !important;
    }

    .ant-btn-primary:hover,
    .ant-btn-primary:focus,
    .ant-btn-primary:active {
        background-color: #40a9ff !important;
        border-color: #40a9ff !important;
        color: white !important;
        box-shadow: none !important;
        height: 40px !important;
        min-height: 40px !important;
        max-height: 40px !important;
    }

    .ant-btn-default {
        height: 40px;
        font-size: 14px;
        font-weight: 600;
        padding: 0 16px;
        border-radius: 8px;
        box-shadow: none !important;
        min-height: 40px !important;
        max-height: 40px !important;
    }

    .ant-btn {
        box-shadow: none !important;
    }

    .ant-btn:hover,
    .ant-btn:focus,
    .ant-btn:active {
        box-shadow: none !important;
    }

    /* Remove red/danger styling */
    .ant-btn-dangerous,
    .ant-btn-dangerous:hover,
    .ant-btn-dangerous:focus,
    .ant-btn-dangerous:active,
    .ant-btn[data-type="danger"],
    .ant-btn[data-type="danger"]:hover,
    .ant-btn[data-type="danger"]:focus,
    .ant-btn[data-type="danger"]:active {
        background-color: #f5f5f5 !important;
        border-color: #d9d9d9 !important;
        color: rgba(0, 0, 0, 0.88) !important;
        box-shadow: none !important;
    }

    /* Compact Popconfirm action buttons */
    .compact-popconfirm .ant-popconfirm-buttons {
        display: flex !important;
        gap: 8px !important;
    }

    .compact-popconfirm .ant-popconfirm-buttons .ant-btn {
        flex: 1 1 0 !important;
        height: 26px !important;
        min-height: 26px !important;
        max-height: 26px !important;
        margin: 0 !important;
        padding: 0 12px !important;
        font-size: 12px !important;
        line-height: 1 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    /* Compact modal footer buttons */
    .compact-modal-btn.ant-btn {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        padding: 0 16px !important;
        font-size: 13px !important;
    }

    .ant-menu-item-danger,
    .ant-menu-item-danger:hover,
    .ant-menu-item-danger:active {
        color: rgba(0, 0, 0, 0.88) !important;
        background-color: transparent !important;
    }

    /* Form item spacing */
    .ant-form-item {
        margin-bottom: 24px;
    }

    /* TextArea large size */
    .ant-input-lg.ant-input,
    .ant-input.ant-input-lg {
        font-size: 16px;
        padding: 12px 16px;
        line-height: 1.6;
    }

    /* Override height restrictions for TextAreas to allow rows to work */
    .ant-input.ant-input-lg[data-testid="textarea"],
    textarea.ant-input,
    .ant-input[aria-expanded],
    textarea {
        height: auto !important;
        min-height: auto !important;
        max-height: none !important;
    }

    /* TextArea for descriptions should be larger */
    .ant-input[data-type="description"],
    textarea[data-type="description"] {
        min-height: 80px !important;
        font-size: 16px !important;
        line-height: 1.6 !important;
        padding: 12px 16px !important;
    }
    
    /* Collapsed sidebar submenu popup styling */
    .ant-menu-submenu-popup {
        z-index: 1050 !important;
        
        .ant-menu {
            background: white !important;
            border-radius: 8px !important;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
            border: 1px solid ${COLORS.border} !important;
            padding: 8px 0 !important;
            min-width: 180px !important;
            
            .ant-menu-item {
                margin: 4px 8px !important;
                padding: 8px 16px !important;
                height: auto !important;
                line-height: 1.5 !important;
                border-radius: 6px !important;
                color: ${COLORS.textDark} !important;
                font-weight: 500 !important;
                
                .ant-menu-item-icon {
                    margin-right: 10px !important;
                    font-size: 16px !important;
                    color: ${COLORS.textDark} !important;
                }
                
                &:hover {
                    background: ${COLORS.backgroundLight} !important;
                    color: ${COLORS.textDark} !important;
                }
                
                &.ant-menu-item-selected {
                    background: ${COLORS.textDark} !important;
                    color: white !important;
                    
                    .ant-menu-item-icon {
                        color: white !important;
                    }
                }
            }
        }
        
        /* Popup title styling */
        .ant-menu-submenu-title {
            display: none !important;
        }
    }
`;

export default GlobalStyles;
